import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	ourAddresses: [
		{
			'id': 'footer.ourAddress1',
			'defaultMessage': '<span>Roman Chachanashvili</br>roman.chachanashvili@stog.io</span></br>+7-925-008-16-90',
		},
		{
			'id': 'footer.ourAddress2',
			'defaultMessage': '<span>Artur Sherbatov</br>artur.sherbatov@stog.io</span><br/>+972-50-44-666-95',
		},
		{
			'id': 'footer.ourAddress3',
			'defaultMessage': '<span>Alex Shtromberg</br>onestromberg@gmail.com</span><br/>+972-55-945-98-44',
		},
	],
	copyright: {
		'id': 'footer.copyright',
		'defaultMessage': 'Copyright © 2018 Apple Inc. All rights reserved.',
	},
	aboutUs: {
		'id': 'footer.aboutUs',
		'defaultMessage': 'Subscribe to our newsletter to be always up-to-date with our news and everything. We love that you’re with us now.',
	},
	privacy: {
		'id': 'footer.privacy',
		'defaultMessage': 'Privacy policy',
	},
	terms: {
		'id': 'footer.terms',
		'defaultMessage': 'Terms of use',
	},
	facebook: {
		'id': 'footer.facebook',
		'defaultMessage': 'f',
	},
	twitter: {
		'id': 'footer.twitter',
		'defaultMessage': 't',
	},
	instagram: {
		'id': 'footer.instagram',
		'defaultMessage': 'i',
	},

});





// WEBPACK FOOTER //
// ./src/components/Footer/messages.js